/* CARAVIUM PLANIFICAR LIVE TRIP — retired. Logic unified in caravium-planificar-wizard-final-fix.js */
(function(){
'use strict';
if(!location.pathname.includes('/pages/planificar')) return;
})();